export const roundPrice = (price) => {
  const num = parseFloat(price);

  if (isNaN(num)) return 0; // fallback safety

  return Math.round(num);
};

